import { throttle } from 'lodash-es'
import { type RefObject, useEffect, useRef, useState } from 'react'

import { noOp } from '@/utils/helpers'

const THROTTLE_MILLISECONDS = 100

export default function useIsVisible<T extends HTMLElement>({
  onVisible = noOp,
}: {
  onVisible?: () => void
}): [RefObject<T>, boolean] {
  const ref = useRef<T>(null)
  const [isVisible, setIsVisible] = useState(false)

  const onScroll = throttle(() => {
    if (ref.current == null) {
      setIsVisible(false)
      return
    }
    const { top } = ref.current.getBoundingClientRect()
    if (top >= 0 && top <= window.innerHeight) {
      setIsVisible(true)
      onVisible()
    }
  }, THROTTLE_MILLISECONDS)

  useEffect(() => {
    document.addEventListener('scroll', onScroll, true)
    return () => document.removeEventListener('scroll', onScroll, true)
  })

  return [ref, isVisible]
}
